
module.exports = { 
      attributes: {},
    
      body: "Allied Health Assistant services work under the direct supervision of health care professionals to provide therapeutic and program-related support including health promotion programs, health prevention programs, rehabilitation, cardiac, acute and primary care services to ensure improved access to services and streamline community and allied health services.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/categoryInfo-allied.md"},
     }